
/**
 * Default application configuration.
 */

import { PRIMARY_COLOR, SECONDARY_COLOR } from "../../color-constants";

const defaultTechnologies = {
  plc: true,
  pac: true,
  edge: true,
  software_licence: true
}

const defaultEnabledTechnologies = {
  plc: true,
  pac: true,
  edge: true,
  pac_complex: true
}

const defaultAvailableRanges = {
  plc: [],
  pac: [],
  edge: [],
  software_licence: []
};

const defaultStartPageFilters = {
  technologies: [],
  ranges: [],
  references: []
};

export let appConfiguration = {
  locale: 'en-WW',  // Locale of the application
  backUrl: window.location.href.split('?')[0],
  domain: new URL(window.location.href).hostname,
  technologies: defaultTechnologies,
  availableRanges: defaultAvailableRanges,
  showMissingLabels: null,
  plcSearch: null,
  searchType: null,
  color: {},
  campaignId: null,
  distributorURL: null,
  addToMyProductLabel: null,
  addToListLabel: null,
  preferredProductReference: null,
  datasheetTemplate: null,
  main: null,
  distributorUnscoping: null,
  toolMainTechnology: null,
  startPageFilters: defaultStartPageFilters,
  seamlessToken: null,
  idpApp: null,
  seamlessEnv: null,
  seamlessSession: null,
  launchFromWorkspace: false,
  showDistributorSurvey: false,
  isWorkspaceAvailable: false,
  unifiedCheckoutAvailable: false,
  ignoreParametersRedirection: false,
  enabledTechnologies: defaultEnabledTechnologies,
  isPublicInternal: null,
  launchFromScript: false,
  licenseSelectorId: null,
  allowPrecommercialization: [],
  globalStyles: {
    primaryColor: PRIMARY_COLOR,
    secondaryColor: SECONDARY_COLOR,
    hoverColor: PRIMARY_COLOR,
    textColor: 'white',
    hoverTextColor: 'white',
    secondaryTextColor: 'white',
    secondaryHoverColor: '#0087CD',
    secondaryHoverTextColor: 'white'
  },
  configurationId: null,
  preventCallByRangeBackToStart: false,
  disableCallByRangeBackToStart: false
}

function buildStartPageFilters(distributorConfiguration) {
  let result = JSON.parse(JSON.stringify(defaultStartPageFilters));
  try {
    if (distributorConfiguration.technology) {
      distributorConfiguration.technology.split(';').forEach(tech => result.technologies.push(tech));
    } else if (distributorConfiguration.toolMainTechnology) {
      distributorConfiguration.toolMainTechnology.split(';').forEach(tech => result.technologies.push(tech));
    }
    if (distributorConfiguration.range_id) {
      distributorConfiguration.range_id.split(';').forEach(range => result.ranges.push(range));
    }
    if (distributorConfiguration.reference) {
      distributorConfiguration.reference.split(';').forEach(ref => result.references.push(ref));
    }
  } catch (error) { }

  return result;
}

function processDistributorColors(distributorColors) {
  const result = {
    primary: PRIMARY_COLOR,
    secondary: SECONDARY_COLOR
  };

  if (distributorColors) {
    result.primary = distributorColors.primary || PRIMARY_COLOR;
    result.secondary = distributorColors.secondary || SECONDARY_COLOR
  }

  return result;
}

export function initAppConfiguration() {
  const distributorConfiguration = window.msxConfiguration;

  let domain;

  try {
    domain = distributorConfiguration.elbridgehostURL ? new URL(distributorConfiguration.elbridgehostURL).hostname :
      (window.msxConfiguration.hostname ? new URL(window.msxConfiguration.hostname).hostname : appConfiguration.domain)
      ;
  } catch (error) {
    try {
      domain = distributorConfiguration.elbridgehostURL ? distributorConfiguration.elbridgehostURL :
        (window.msxConfiguration.hostname ? new URL(window.msxConfiguration.hostname).hostname : appConfiguration.domain)
        ;

    } catch (error2) {
      domain = 'www.se.com';
    }
  }

  if (distributorConfiguration) {
    const startPageFilters = buildStartPageFilters(distributorConfiguration);

    appConfiguration = {
      configurationId: distributorConfiguration.configurationId ? distributorConfiguration.configurationId : appConfiguration.configurationId,
      locale: distributorConfiguration.locale ? distributorConfiguration.locale : appConfiguration.locale,
      backUrl: appConfiguration.backUrl,
      domain: domain,
      plcSearch: distributorConfiguration.plcSearch ? distributorConfiguration.plcSearch :
        (distributorConfiguration.startSearch ? distributorConfiguration.startSearch : appConfiguration.plcSearch)
      ,
      searchType: distributorConfiguration.searchType ? distributorConfiguration.searchType : appConfiguration.searchType,
      showMissingLabels: distributorConfiguration.showMissingLabels ? distributorConfiguration.showMissingLabels : appConfiguration.showMissingLabels,
      color: processDistributorColors(distributorConfiguration.color ? distributorConfiguration.color : appConfiguration.color),
      distributorURL: distributorConfiguration.distributorURL ? distributorConfiguration.distributorURL : appConfiguration.distributorURL,
      addToMyProductLabel: distributorConfiguration.addToMyProductLabel ? distributorConfiguration.addToMyProductLabel : appConfiguration.addToMyProductLabel,
      preferredProductReference: distributorConfiguration.preferredProductReference ? distributorConfiguration.preferredProductReference : appConfiguration.preferredProductReference,
      datasheetTemplate: distributorConfiguration.datasheetTemplate ? distributorConfiguration.datasheetTemplate : appConfiguration.datasheetTemplate,
      main: distributorConfiguration.main ? distributorConfiguration.main : appConfiguration.main,
      distributorUnscoping: distributorConfiguration.distributorUnscoping ? distributorConfiguration.distributorUnscoping.split(';') : appConfiguration.distributorUnscoping,
      seamlessToken: distributorConfiguration.seamlessToken ? distributorConfiguration.seamlessToken : appConfiguration.seamlessToken,
      seamlessEnv: distributorConfiguration.seamlessToken ? distributorConfiguration.seamlessEnv : appConfiguration.seamlessEnv,
      isWorkspaceAvailable: distributorConfiguration.isWorkspaceAvailable ? distributorConfiguration.isWorkspaceAvailable : appConfiguration.isWorkspaceAvailable,
      unifiedCheckoutAvailable: isUnifiedCheckoutAvailable(distributorConfiguration),
      addToListLabel: processAddToListLabel(distributorConfiguration),
      technologies: distributorConfiguration.technologies ? distributorConfiguration.technologies : appConfiguration.technologies,
      availableRanges: appConfiguration.availableRanges,
      toolMainTechnology: distributorConfiguration.toolMainTechnology ? distributorConfiguration.toolMainTechnology : appConfiguration.toolMainTechnology,
      startPageFilters,
      launchFromWorkspace: distributorConfiguration.launchFromWorkspace ? distributorConfiguration.launchFromWorkspace : appConfiguration.launchFromWorkspace,
      showDistributorSurvey: distributorConfiguration.showDistributorSurvey ? distributorConfiguration.showDistributorSurvey : appConfiguration.showDistributorSurvey,
      ignoreParametersRedirection: distributorConfiguration.ignoreParametersRedirection ? distributorConfiguration.ignoreParametersRedirection : appConfiguration.ignoreParametersRedirection,
      enabledTechnologies: distributorConfiguration.enabledTechnologies ? buildEnabledTechnologies(distributorConfiguration.enabledTechnologies) : appConfiguration.enabledTechnologies,
      campaignId: distributorConfiguration.campaignId ? distributorConfiguration.campaignId : appConfiguration.campaignId,
      launchFromScript: distributorConfiguration.launchFromScript ? distributorConfiguration.launchFromScript : appConfiguration.launchFromScript,
      licenseSelectorId: distributorConfiguration.licenseSelectorId ? distributorConfiguration.licenseSelectorId : appConfiguration.licenseSelectorId,
      idpApp: distributorConfiguration.idpApp ? distributorConfiguration.idpApp : appConfiguration.idpApp,
      allowPrecommercialization: distributorConfiguration.allowPrecommercialization ? buildAllowPrecommercialization(distributorConfiguration.allowPrecommercialization) : appConfiguration.allowPrecommercialization,
      preventCallByRangeBackToStart: distributorConfiguration.preventCallByRangeBackToStart ? distributorConfiguration.preventCallByRangeBackToStart : appConfiguration.preventCallByRangeBackToStart,
      disableCallByRangeBackToStart: false
    };
  }
}

function isUnifiedCheckoutAvailable(distributorConfiguration) {
  if (distributorConfiguration.buttons) {
    return !!distributorConfiguration.buttons?.addToListConfiguration?.isVisible;
  }

  return distributorConfiguration.unifiedCheckoutAvailable ? distributorConfiguration.unifiedCheckoutAvailable : appConfiguration.unifiedCheckoutAvailable;
}

function processAddToListLabel(distributorConfiguration) {
  if (distributorConfiguration.buttons) {
    return distributorConfiguration.buttons?.addToListConfiguration?.title;
  }
  return distributorConfiguration.addToListLabel ? distributorConfiguration.addToListLabel : appConfiguration.addToListLabel;
}

function buildEnabledTechnologies(tech) {
  let technologies = defaultEnabledTechnologies;
  if (tech.plc != null) {
    technologies.plc = tech.plc;
  }
  if (tech.pac != null) {
    technologies.pac = tech.pac;
  }
  if (tech.pac_complex != null) {
    technologies.pac_complex = tech.pac_complex;
  }
  if (tech.edge != null) {
    technologies.edge = tech.edge;
  }

  return technologies;
}

function buildAllowPrecommercialization(precomString) {
  const result = [];
  try {
    return precomString.split(';');
  } catch (error) {
    console.warn('Failed to process the precommercialization parameter');
  }

  return result
}

function addPrecommercializationRanges(ranges) {
  const newRanges = [...(appConfiguration.allowPrecommercialization || [])];
  newRanges.push(...ranges);
  appConfiguration.allowPrecommercialization = newRanges;
}

export function setLocale(locale) {
  appConfiguration.locale = locale;
}

export function setSeamlessSession(identityPayload) {
  appConfiguration.seamlessSession = {
    id: identityPayload.user_id,
    name: identityPayload.name,
    email: identityPayload.email,
    isInternal: identityPayload.custom_attributes.isInternal === "TRUE"
  }
  if (identityPayload.custom_attributes) {
    const userChannels = {};
    userChannels.channel1 = identityPayload.custom_attributes.classLevel1;
    userChannels.channel2 = identityPayload.custom_attributes.classLevel2;
    appConfiguration.seamlessSession.userChannels = userChannels;
  }
}

export function setSeamlessSessionWithOkta(identityPayload) {
  appConfiguration.seamlessSession = {
    id: identityPayload.id,
    name: identityPayload.name,
    email: identityPayload.email,
    isInternal: identityPayload.isInternal === "TRUE"
  }
  if (identityPayload.userChannels) {
    const userChannels = {};
    userChannels.channel1 = identityPayload.userChannels.classLevel1;
    userChannels.channel2 = identityPayload.userChannels.classLevel2;
    appConfiguration.seamlessSession.userChannels = userChannels;
  }
}

export function setTechnologies(technologies) {
  appConfiguration.technologies = {
    ...defaultTechnologies,
    ...appConfiguration.technologies,
    ...technologies
  }
}

export function setAvailableRanges(technology, ranges) {
  appConfiguration.availableRanges[technology] = ranges;
}


export function setGlobalStyles(styles) {
  appConfiguration.globalStyles = styles;
}

export function setIsInternal(internalStatus) {

  // Temporary fix for internal user : allow them to see precommercialized EDGE
  if (internalStatus) {
    addPrecommercializationRanges([
      "223435768"
    ]);
  }

  appConfiguration.isPublicInternal = internalStatus;
}

export function unsetLicenseSelectorId() {
  appConfiguration.licenseSelectorId = null;
}

export function setDisableCallByRangeBackToStart(newStatus) {
  appConfiguration.disableCallByRangeBackToStart = newStatus;
}
